import React from 'react';
import HeroBlock from './blocks/HeroBlock';
import VSLBlock from './blocks/VSLBlock';
import CTABlock from './blocks/CTABlock';
import FAQBlock from './blocks/FAQBlock';
import TestimonialsBlock from './blocks/TestimonialsBlock';
import StepsBlock from './blocks/StepsBlock';
import BookingBlock from './blocks/BookingBlock';
import AuthorBlock from './blocks/AuthorBlock';
import OptinForm from './OptinForm';

const BLOCK_RENDERERS = {
  hero: HeroBlock,
  vsl: VSLBlock,
  cta: CTABlock,
  faq: FAQBlock,
  testimonials: TestimonialsBlock,
  steps: StepsBlock,
  booking: BookingBlock,
  author: AuthorBlock,
};

export default function FunnelLayout({ funnel, currentStep, blocks, steps, slug }) {
  const settings = funnel?.settings || {};
  const bgColor = settings.background_color || '#ffffff';
  const maxWidth = settings.max_width ? `${settings.max_width}px` : '680px';
  const fontFamily = settings.font_family || settings.font || undefined;
  const logoUrl = settings.logo_url;
  const disclaimer = settings.disclaimer || settings.disclaimer_text;

  const isOptinStep = currentStep?.step_type === 'optin';

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: bgColor, fontFamily }}
    >
      {logoUrl && (
        <header className="py-4 px-4 flex justify-center">
          <img src={logoUrl} alt="" className="h-8 sm:h-10 object-contain" />
        </header>
      )}

      <main
        className="mx-auto px-4 sm:px-6 pb-12"
        style={{ maxWidth }}
      >
        {(blocks || []).map((block) => {
          const Component = BLOCK_RENDERERS[block.block_type];
          if (!Component) return null;

          const sharedProps = {
            content: block.content,
            slug,
            steps,
          };

          if (block.block_type === 'booking') {
            return (
              <Component
                key={block.id}
                {...sharedProps}
                blockId={block.id}
                funnelId={funnel.id}
                stepId={currentStep.id}
                funnelSlug={slug}
              />
            );
          }

          if (block.block_type === 'cta') {
            return <Component key={block.id} {...sharedProps} />;
          }

          return <Component key={block.id} content={block.content} />;
        })}

        {isOptinStep && (
          <OptinForm
            funnelId={funnel.id}
            stepId={currentStep.id}
            funnelSlug={slug}
            entryPoint={currentStep.step_number}
          />
        )}
      </main>

      {disclaimer && (
        <footer className="px-4 pb-8">
          <p
            className="mx-auto text-center text-xs text-gray-400 leading-relaxed"
            style={{ maxWidth }}
          >
            {disclaimer}
          </p>
        </footer>
      )}
    </div>
  );
}
